import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { CardTranslationEntity } from './CardTranslationEntity'
import type { BranchTagsMiniEntity } from '@/features/branchTags/domain/entities/BranchTagsMiniEntity'
import type { CardLinkType } from '../enyms/CardLinkType'
import type { CardViewType } from '../enyms/CardViewType'
export class CardEntity {
  id?: number
  name?: string | null
  order?: number
  isEnabled?: boolean
  startDate?: string
  expireDate?: string | null
  uri?: string | null
  regions?: Array<{ id?: number; name?: string | null }> | null
  cardRegions?: Array<{ name?: string | null; id?: number; districtIds?: number[] }> | null
  translations?: Array<CardTranslationEntity> | null
  channel?: ChannelMiniEntity
  branchTags?: Array<BranchTagsMiniEntity> | null
  linkType?: CardLinkType
  viewType?: CardViewType
  cardPerBranch?: number
}
